module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG3b8fc320c75fd396cb59d91fde258925.3b8fc320.png";